export default {
    setInputs: (state, inputs) => { state.inputs = inputs },
    setModels: (state, models) => {
        state.models = { ...models }
    }
}